'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _baseForm = _interopRequireDefault(require("./../base-form"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _translate = _interopRequireDefault(require("../translate"));

var _datamasterForms = require("datamaster-forms");

var _formInputs = require("./../form-inputs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var collectionMapping = {
  salutation: 'salutations',
  canton: 'cantons',
  mainlanguage: 'languages',
  placedetails: 'placedetails'
};
var invalidFieldsDefault = {
  fields: [],
  details: {},
  schubforeignorganisator: {
    fields: [],
    details: {}
  },
  schub: {
    fields: [],
    details: {}
  }
};

var SchubForm = /*#__PURE__*/function (_BaseForm) {
  _inherits(SchubForm, _BaseForm);

  function SchubForm(props) {
    var _this;

    _classCallCheck(this, SchubForm);

    _this = _possibleConstructorReturn(this, (SchubForm.__proto__ || Object.getPrototypeOf(SchubForm)).call(this, props));
    _this.state = _lodash.default.extend(_this.state, {
      schubNotFound: props.project ? false : true,
      schub: props.project,
      infrastructures: [],
      targetGroups: [],
      themes: [],
      form: {
        invalidFields: {
          fields: [],
          details: {},
          schubforeignorganisator: {
            fields: [],
            details: {}
          },
          schub: {
            fields: [],
            details: {}
          }
        }
      }
    });
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleInputChangeMultiSelect = _this.handleInputChangeMultiSelect.bind(_assertThisInitialized(_this));
    _this.handleOrganizatorRadioField = _this.handleOrganizatorRadioField.bind(_assertThisInitialized(_this));
    _this.handleForeignOrganizatorFields = _this.handleForeignOrganizatorFields.bind(_assertThisInitialized(_this));
    _this.handleRadioField = _this.handleRadioField.bind(_assertThisInitialized(_this));
    _this.saveSchub = _this.saveSchub.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   */


  _createClass(SchubForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      //Uncomment this block when we allow the edit mode on this component
      fetch(_conf.default.api.themesApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (themes) {
        _this2.setState(function (prev) {
          prev.themes = themes;
          return prev;
        });
      }).catch(function (err) {
        throw err;
      });
      fetch(_conf.default.api.infrastructuresApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (infrastructures) {
        _this2.setState(function (prev) {
          prev.infrastructures = infrastructures;
          return prev;
        });
      }).catch(function (err) {
        throw err;
      });
      fetch(_conf.default.api.targetGroupsApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (targetGroups) {
        _this2.setState(function (prev) {
          prev.targetGroups = targetGroups;
          return prev;
        });
      }).catch(function (err) {
        throw err;
      });
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;

      if (this.state.schubNotFound) {
        return /*#__PURE__*/_react.default.createElement("p", null, t('Not registered'));
      }

      _lodash.default.merge(this.state.form.invalidFields, this.state.invalidFields);

      _lodash.default.merge(this.state.schub.organisatortype, this.props.project.organisatortype);

      _lodash.default.merge(this.state.schub.foreignorganizator, this.props.project.foreignorganizator);

      _lodash.default.merge(this.state.schub.locationtype, this.props.project.locationtype);

      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.anchorId || '',
        className: "comp-farm comp-base-form"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "Schub",
        className: "form-title"
      }, t('Project data')), !_lodash.default.isEmpty(this.state.schub) ? /*#__PURE__*/_react.default.createElement(_datamasterForms.ProjectSchubForm, {
        t: t,
        history: this.props.history,
        handleInputChange: this.handleInputChange,
        handleInputMultiSelectChange: this.handleInputChangeMultiSelect,
        handleOrganizatorRadioField: this.handleOrganizatorRadioField,
        handleForeignOrganizatorFields: this.handleForeignOrganizatorFields,
        handleRadioField: this.handleRadioField,
        project: this.state.schub,
        saveThemeFields: this.saveSchub,
        saveTargetGroupFields: this.saveSchub,
        saveInfrastructureFields: this.saveSchub,
        saveOrganizerFields: this.saveSchub,
        saveSchubLocationFields: this.saveSchub,
        shared: {
          infrastructures: this.state.infrastructures,
          themes: this.state.themes,
          targetGroups: this.state.targetGroups,
          placedetails: this.props.placedetails,
          canton: this.props.cantons,
          salutation: this.props.salutations,
          mainlanguage: this.props.languages
        },
        progress: {
          organizer: null,
          schubLocation: null,
          infrastructure: null,
          themes: null,
          targetGroups: null
        },
        organisatortype: [{
          id: 1,
          name: 'Eigene Adresse'
        }, {
          id: 3,
          name: 'Andere Adresse'
        }],
        locationtype: [{
          id: 1,
          name: 'Eigener Hof'
        }, {
          id: 3,
          name: 'Anderer Hof'
        }],
        isSaving: {
          infrastructures: this.state.isSaving,
          themes: this.state.isSaving,
          targetGroups: this.state.isSaving
        },
        success: {
          infrastructures: this.state.success,
          themes: this.state.success,
          targetGroups: this.state.success,
          schubLocation: this.state.success,
          organizer: this.state.success
        },
        error: {
          infrastructures: this.state.error,
          themes: this.state.error,
          targetGroups: this.state.error,
          schubLocation: this.state.error,
          organizer: this.state.error
        },
        invalidFields: this.state.form.invalidFields,
        MultiSelectText: _formInputs.AdapterMultiSelect,
        InputField: _formInputs.AdapterText,
        InputTelephone: _formInputs.TelephoneInput,
        InputCheckbox: _formInputs.CheckboxInput,
        InputSelect: _formInputs.AdapterSelect,
        InputRadioGroup: _formInputs.InputRadioGroup,
        InputSwitch: _formInputs.InputSwitch,
        InputTextarea: _formInputs.TextareaInput
      }) : null);
    }
    /**
     *
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(e) {
      var target = e.target;
      var value = target.value,
          name = target.name;

      if (name === 'salutation') {
        value = this.props.salutations.filter(function (item) {
          return item.id === value;
        })[0];
        this.setState(function (prev) {
          prev.schub.salutation_id = target.value;
        });
      }

      if (name === 'canton') {
        value = this.props.cantons.filter(function (item) {
          return item.id === parseInt(value);
        })[0];
        this.setState(function (prev) {
          prev.schub.canton_id = target.value;
        });
      }

      this.setState(function (prev) {
        prev.schub[name] = value;
        return prev;
      });
    }
    /**
     *
     */

  }, {
    key: "handleInputChangeMultiSelect",
    value: function handleInputChangeMultiSelect(fieldName, elements) {
      this.setState(function (prev) {
        prev.schub[fieldName] = prev[fieldName].filter(function (element) {
          return elements.indexOf(parseInt(element.id)) !== -1;
        });
      });
    }
    /**
     *
     * @param event
     * @returns {*}
     */

  }, {
    key: "handleOrganizatorRadioField",
    value: function handleOrganizatorRadioField(event) {
      var target = event.target,
          name = target.name;
      var value;

      if (name === 'organisatortype' || name === 'locationtype') {
        value = _lodash.default.find(this.props[name], ['id', target.value]) || _lodash.default.find(this.props[name], ['id', parseInt(target.value)]);
      }

      if (name === 'organisatortype' && parseInt(target.value) === 3) {
        if (this.props.project.farmforeignorganizator.id === -1) {
          return this.props.updateSchubForeignOrganisator(name, value);
        }
      }

      this.props.updateProject(name, value);
    }
    /**
     *
     * @param event
     * @param fieldName
     * @param newVal
     * @returns {*|void}
     */

  }, {
    key: "handleForeignOrganizatorFields",
    value: function handleForeignOrganizatorFields(event, fieldName, newVal) {
      if (fieldName) {
        this.props.updateProject(fieldName, newVal);
      }

      var target = event.target,
          name = target.name,
          type = target.type;
      var value;
      if (type === 'checkbox') value = target.checked;else if (type === 'select-one') {
        if (name === 'languageofcorrespondence') {
          value = _lodash.default.find(this.props.languages, ['id', target.value]) || _lodash.default.find(this.props.languages, ['id', parseInt(target.value)]);
        } else {
          value = _lodash.default.find(this.props[collectionMapping[name]], ['id', target.value]) || _lodash.default.find(this.props[collectionMapping[name]], ['id', parseInt(target.value)]);
        }
      } else {
        value = target.value;
      }
      this.props.updateProject('foreignorganizator.' + name, value);
    }
    /**
     *
     * @param e
     * @param fieldName
     * @param newVal
     */

  }, {
    key: "handleRadioField",
    value: function handleRadioField(e, fieldName, newVal) {
      if (fieldName) {
        var value = _lodash.default.find(this.props[fieldName], ['id', newVal]) || _lodash.default.find(this.props[fieldName], ['id', parseInt(newVal)]);

        this.props.updateProject(fieldName, value);
      }
    }
    /**
     *
     * @returns {Promise<Response | never>}
     */

  }, {
    key: "deleteForeignorganisator",
    value: function deleteForeignorganisator() {
      var orgType = _lodash.default.get(this.state, 'schub.organisatortype.id');

      if ((orgType === 1 || orgType === 2) && _lodash.default.get(this.state, 'schub.foreignorganizator.id') != null) {
        return fetch(_conf.default.api.schubForeignOrganisatorByIdApiTemplate(this.props.i18n.language, _lodash.default.get(this.state, 'schub.foreignorganizator.id')), {
          credentials: 'include',
          method: 'DELETE'
        }).then(_fetchUtils.default.checkStatus);
      }

      return Promise.resolve();
    }
    /**
     *
     * @returns {Promise<Response | never>}
     */

  }, {
    key: "saveSchub",
    value: function saveSchub() {
      var _this3 = this;

      this.setState({
        isSaving: true
      }, function () {
        _this3.deleteForeignorganisator().then(function () {
          var project = _lodash.default.cloneDeep(_this3.state.schub);

          delete project.farm;

          if (_lodash.default.get(project, 'organisatortype.id') && _lodash.default.get(project, 'organisatortype.id') !== 3) {
            delete project.farmforeignorganizator;
            delete project.foreignorganizator;
          }

          delete project.images;
          delete project.documents;
          return fetch(_conf.default.api.schubApiUrlTemplate(_this3.props.i18n.language, _this3.props.id), {
            method: 'PUT',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(project)
          });
        }).then(_fetchUtils.default.checkStatus).then(function (response) {
          _this3.resetSaveError(function () {
            _this3.setState(function (prev) {
              prev.error = undefined;
              prev.success = true;
              prev.isSaving = false;
              prev.schub = _this3.props.projectAfterLoad(response);
              return prev;
            });
          });
        }).catch(function (err) {
          _this3.handleSaveErrors(err);

          void 0;
        });
      });
    }
    /**
     *
     * @param response
     */

  }, {
    key: "handleSaveErrors",
    value: function handleSaveErrors(response) {
      var _this4 = this;

      var message = response.message;
      var context = _lodash.default.get(response, 'details.context') || 'schub';
      this.resetSaveError(function () {
        if (response.status === 422) {
          var fields = _lodash.default.get(response, 'details.codes', {});

          _this4.setState(function (prev) {
            prev.invalidFields[context] = {
              fields: Object.keys(fields),
              details: fields
            };
            prev.error = message;
            prev.success = false;
            prev.isSaving = false;
            return prev;
          });
        }
      });
    }
    /**
     *
     */

  }, {
    key: "resetSaveError",
    value: function resetSaveError(cb) {
      this.setState(function (prev) {
        prev.invalidFields = _lodash.default.cloneDeep(invalidFieldsDefault);
        prev.error = '';
        return prev;
      }, cb);
    }
  }]);

  return SchubForm;
}(_baseForm.default);

var _default = (0, _translate.default)(SchubForm);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/schub/schub.js
// module id = 707
// module chunks = 0